var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../baseService';
export class Notifications extends BaseService {
    constructor(props) {
        super(props);
    }
    // async create(params: CRUD['Create'], options?: Options) {
    //   let res: CRUD['CreateResponse']
    //   res = await this.api.fetchLoggedV3('user.notifications.create', params, options)
    //   return { ...res, preparedValue: res.prepared?.notification }
    // }
    //
    // async read(params: CRUD['Read'], options?: Options) {
    //   let res: CRUD['ReadResponse']
    //   res = await this.api.fetchLoggedV3('user.notifications.read', params, options)
    //   return { ...res, preparedValue: res.prepared?.notification }
    // }
    //
    // async delete(params: CRUD['Delete'], options?: Options) {
    //   let res: CRUD['DeleteResponse']
    //   res = await this.api.fetchLoggedV3('user.notifications.delete', params, options)
    //   return res
    // }
    list(params, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('user.notifications.list', params, options);
            return Object.assign(Object.assign({}, res), { preparedValue: ((_a = res.prepared) === null || _a === void 0 ? void 0 : _a.notifications.items) || [] });
        });
    }
}
